import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAudienceStore = create(
  persist(
    (set) => ({
      isAudienceSaved: false,
      setIsAudienceSaved: (val) => set({ isAudienceSaved: val }),
    }),
    {
      name: 'explorer:has_changes', // key in localStorage
    }
  )
);

export default useAudienceStore;
